export enum ChannelEnum {
  TOKOPEDIA = "tokopedia",
  SHOPEE = "shopee",
  TIKTOK = "tiktok",
  CATALOG = "melaka_catalog",
  OFFLINE = "offline",
}

export default ChannelEnum;
